import { EMAIL_PATTERN } from '@consigli/hooks';
import { Language, OrganizationRole } from '@consigli/types';

import { FormErrors, InviteFormData } from './types';

export const validateInviteForm = (
  formData: InviteFormData,
): { isValid: boolean; errors: FormErrors } => {
  const errors: FormErrors = {};

  if (formData.recipients.length === 0) {
    errors.recipients = 'At least one recipient is required';
  } else {
    const invalid = formData.recipients.find((email) => !EMAIL_PATTERN.test(email));
    const nonAecom = formData.recipients.find(
      (email) => !email.toLowerCase().endsWith('@aecom.com'),
    );
    if (invalid) {
      errors.recipients = `Invalid email: ${invalid}`;
    } else if (nonAecom) {
      errors.recipients = `Only @aecom.com email addresses can be invited (${nonAecom})`;
    }
  }

  // Validate language
  if (!formData.language) {
    errors.language = 'Language is required';
  }

  // Validate role
  if (!formData.organizationRole) {
    errors.organizationRole = 'Role is required';
  }

  // Validate organization for admin role or user with canCreateProjects
  if (
    formData.organizationRole === OrganizationRole.ADMIN ||
    (formData.organizationRole === OrganizationRole.USER && formData.canCreateProjects)
  ) {
    if (!formData.organizationId) {
      errors.organizationId = 'Organization is required';
    }
  }

  // Validate project access for users who can't create projects
  if (
    formData.organizationRole === OrganizationRole.USER &&
    !formData.canCreateProjects &&
    formData.projects.length === 0
  ) {
    errors.projects = 'User must be able to create projects or have at least one project access';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const languageOptions = [
  { label: 'English', value: Language.EN },
  { label: 'French', value: Language.FR },
  { label: 'German', value: Language.DE },
  { label: 'Japanese', value: Language.JA },
  { label: 'Norwegian Bokmål', value: Language.NB },
  { label: 'Norwegian Nynorsk', value: Language.NN },
  { label: 'Spanish', value: Language.ES },
  { label: 'Catalan', value: Language.CA },
  { label: 'Swedish', value: Language.SV },
  { label: 'Vietnamese', value: Language.VI },
  { label: 'Chinese', value: Language.ZH },
];

export const roleOptions = [
  { label: 'Admin', value: OrganizationRole.ADMIN },
  { label: 'User', value: OrganizationRole.USER },
];
